import { render, staticRenderFns } from "./DepositsfromWarehouse.vue?vue&type=template&id=485c4230"
import script from "./DepositsfromWarehouse.vue?vue&type=script&lang=js"
export * from "./DepositsfromWarehouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports